module.exports = __webpack_public_path__ + "img/borderCornerShadowWhite.e421b9c1.svg";